import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import useTranslation from '@src/hooks/useTranslation';

import { getEventPriceRange, getTicketStatus } from '@src/utils/event';
import { IColors } from '@src/types/theme';
import { getColorTheme } from '@src/store/selectors/theme';
import { CURRENCY_SYMBOL } from '@src/const/common';
import {
	HostBy,
	PriceRange,
} from '@src/components/card/style';
import InfoByStatus from '@src/components/card/infoByStatus';
import { MediumCard as BasicMediumCard } from '@src/components/card/basic';
import { getPrice } from '@src/components/card/utils';
import { getIsPriceVisible } from '@src/utils/hardcode';

const StyledPriceRange = styled(PriceRange)`
	margin-top: 12px;
`;

interface IProps {
	onClick: () => void;
	event: any;
}

const MediumCard = ({
	onClick,
	event,
}: IProps): JSX.Element => {
	const { t } = useTranslation();
	const { id: eventId } = event || {};
	const isPriceVisible = getIsPriceVisible(eventId);
	const {
		name: title,
		host_by: hostBy,
		photos,
		slots,
	} = event;
	const photoLinks = photos.map(photo => photo.link);
	const { status, countDownTime } = getTicketStatus({ slots });
	let price = { minPrice: 0, maxPrice: 0 };
	if (event.slots.length) {
		price = getEventPriceRange(event.slots);
	}
	const { minPrice, maxPrice } = price;
	const { colors: { primary } } = useSelector(getColorTheme) as { colors: IColors };
	const isFree = (minPrice === maxPrice) && minPrice === 0;

	return (
		<BasicMediumCard
			onClick={onClick}
			title={title}
			tagText={t('training:course:offline_event:event')}
			tagColor={primary}
			imageUrl={photoLinks[0]}
			imageAlt={photos[0]?.alt_title}
			contentElem={(
				<>
					<HostBy>{hostBy}</HostBy>
					<InfoByStatus status={status} countDownTime={countDownTime} slots={slots} />
					<StyledPriceRange>
						{
							isPriceVisible ? (
								<>
									{!isFree && <span className="price-range__currency">{CURRENCY_SYMBOL}</span>}
									<span className="price-range__number">
										{getPrice({ minPrice, maxPrice })}
									</span>
								</>
							) : (
								<>{t('common:action:consultation')}</>
							)
						}
					</StyledPriceRange>
				</>
			)}
		/>
	);
};

export default MediumCard;
